import * as React from 'react';
import { useState } from 'react';
import { PaywallSniperWrapper, LabelWrapper, InputWrapper, ArticleWrapper, InputSection, ContentWrapper, LoadingText } from './PaywallSniperStyles';
import { CallToActionButtonLayout, Props as CTAProps } from '../../Components/CallToActionButton/CallToActionButtonLayout';
import { InputFieldLayout, Props as InputProps } from '../../Components/InputField/InputFieldLayout';
import { LoadingLayout, Props as LoadingProps } from '../../Components/LoadingComponent/LoadingLayout';
import { ThemeProvider } from '@mui/material/styles';
import { generateArticle } from './helpers/generateArticle';
import { createDarkTheme } from './helpers/createDarkTheme';

export type Props = {
	input: boolean;
	loading: boolean;
	data: string | null;
	handleSnipe: () => void;
	setUrl: (url: string) => void;
	// optional controlled url value (if provided, input will be controlled)
	url?: string | null;
};

const darkTheme = createDarkTheme();
const expectedWaitTimeCeiling = 90;

export const PaywallSniperLayout = (props: Props) => {
	const [time, setTime] = useState(expectedWaitTimeCeiling);
	const handleSnipe = () => {
		setTime(expectedWaitTimeCeiling);
		props.handleSnipe();
		setInterval(() => {
			const prevTime = time;
			setTime((prevTime) => (prevTime > 0 ? prevTime - 1 : 0));
		}, 1000);
	};
	const render = () => {
		const ctaProps: CTAProps = {
			text: 'Snipe',
			onClick: handleSnipe,
		};

		const inputProps: InputProps = {
			placeholder: 'URL to Snipe',
			value: props.url ?? undefined,
			onChange: (e: React.ChangeEvent<HTMLInputElement>) => {
				props.setUrl(e.target.value);
			},
		};

		const inputJSX = (
			<InputSection>
				<ThemeProvider theme={darkTheme}>
					<LabelWrapper>
						<InputFieldLayout {...inputProps} />
					</LabelWrapper>
					<InputWrapper>
						<CallToActionButtonLayout {...ctaProps} />
					</InputWrapper>
				</ThemeProvider>
			</InputSection>
		);
		const articleJSX = !props.data ? null : <ArticleWrapper>{generateArticle(props.data)}</ArticleWrapper>;
		const loadingProps: LoadingProps = {
			fullHeight: true,
			message: `This should take about a ${time} seconds`,
		};
		const loadingJSX = (
			<PaywallSniperWrapper>
				<LoadingLayout {...loadingProps} />
				<LoadingText></LoadingText>
			</PaywallSniperWrapper>
		);

		const contentJSX = (
			<PaywallSniperWrapper>
				<ContentWrapper>
					{inputJSX}
					{articleJSX}
				</ContentWrapper>
			</PaywallSniperWrapper>
		);

		return props.loading ? loadingJSX : contentJSX;
	};
	return render();
};
